export { default } from './FormGeneratorCombinedFieldCDS';
